import { render, staticRenderFns } from "./laborbaseline.vue?vue&type=template&id=a36f16d2&lang=pug"
import script from "./laborbaseline.vue?vue&type=script&lang=js"
export * from "./laborbaseline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports